// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32UIk","label":"styles_label__2c-1a"};